/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicBudgetInsights extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicBudgetInsights");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicBudgetInsights.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicBudgetInsights>): BackgroundJobPayloadForPeriodicBudgetInsights {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicBudgetInsights(), model);
        BackgroundJobPayloadForPeriodicBudgetInsights.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicBudgetInsights>): BackgroundJobPayloadForPeriodicBudgetInsights {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicBudgetInsights.newInstance(<BackgroundJobPayloadForPeriodicBudgetInsights> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicBudgetInsights) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicBudgetInsights.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicBudgetInsights): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicBudgetInsights.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
